import { TranslocoModule, provideTranslocoScope } from '@jsverse/transloco';
import { Component, Input, OnInit } from '@angular/core';
import { MatChipsModule } from '@angular/material/chips';
import { ListPageColumnComponent } from 'design-system';

@Component({
  providers: [provideTranslocoScope('products')],
  selector: 'prd-category-chip',
  imports: [MatChipsModule, TranslocoModule],
  templateUrl: './category-chip.html',
  styleUrl: './category-chip.scss',
})
export class CategoryChip extends ListPageColumnComponent implements OnInit {
  @Input() badges: string[] = [];
  @Input() translate = true;

  ngOnInit() {
    if (this.itemData && this.infoColumn) {
      this.badges = this.itemData[this.infoColumn.columnNameDef] ?? [];
    }
  }
}
